import { render, staticRenderFns } from "./ECommerceAdd.vue?vue&type=template&id=20e234e0&scoped=true&"
import script from "./ECommerceAdd.vue?vue&type=script&lang=js&"
export * from "./ECommerceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e234e0",
  null
  
)

export default component.exports